import { render, staticRenderFns } from "./pre-dialog.vue?vue&type=template&id=28c7123c&scoped=true&"
import script from "./pre-dialog.vue?vue&type=script&lang=js&"
export * from "./pre-dialog.vue?vue&type=script&lang=js&"
import style0 from "./pre-dialog.vue?vue&type=style&index=0&id=28c7123c&prod&lang=less&scoped=true&"
import style1 from "./pre-dialog.vue?vue&type=style&index=1&id=28c7123c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7123c",
  null
  
)

export default component.exports